var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._g(_vm._b({directives:[{name:"mask",rawName:"v-mask",value:(_vm.field.mask),expression:"field.mask"}],class:("ep-textfield-" + (_vm.valid ? 'valid' : 'invalid')),style:({
    height: '50px',
    background: '#FFFFFF',
    border: '1px solid #E0E0E0',
    borderRadius: '8px',
    boxShadow: 'none'
  }),attrs:{"type":"text","tabindex":_vm.field.tabIndex,"required":_vm.field.required,"loading":_vm.field.loading,"hint":_vm.field.hint,"persistent-hint":!!_vm.field.hint,"value":_vm.value,"solo":""},on:{"input":function (value) { return _vm.$emit('input', value); }}},'v-text-field',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }